import { Component, h } from '@stencil/core';

@Component({
  tag: 'signet-h1',
  styleUrl: 'signet-h1.scss',
  shadow: true,
})
export class SignetH1 {
  render() {
    return (
      <h1>
        <slot />
      </h1>
    );
  }
}
